import Translations from "translations/types";

export const SEARCH_MERGE_AUCTION_STARTED_KEY = "search_merge_started" as const;

const SEARCH_MERGE_AUCTION_STARTED_STEPS = {
  CONTACTED_TABLE: "contacted_table",
  PATIENT_WISH: "patient_wish",
  STATUS: "status",
} as const;

export const SEARCH_MERGE_AUCTION_STARTED = {
  disablePageScroll: true,
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  exitOnOverlayClick: false,
  key: SEARCH_MERGE_AUCTION_STARTED_KEY,
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  steps: {
    [SEARCH_MERGE_AUCTION_STARTED_STEPS.CONTACTED_TABLE]: {
      intro: (t: Translations) => t.tours.searchMergeContacted.stepA.intro,
      key: SEARCH_MERGE_AUCTION_STARTED_STEPS.CONTACTED_TABLE,
      step: 1,
      title: (t: Translations) => t.tours.searchMergeContacted.stepA.title,
    },
    [SEARCH_MERGE_AUCTION_STARTED_STEPS.PATIENT_WISH]: {
      intro: (t: Translations) => t.tours.searchMergeContacted.stepB.intro,
      key: SEARCH_MERGE_AUCTION_STARTED_STEPS.PATIENT_WISH,
      step: 2,
      title: (t: Translations) => t.tours.searchMergeContacted.stepB.title,
    },
    [SEARCH_MERGE_AUCTION_STARTED_STEPS.STATUS]: {
      intro: (t: Translations) => t.tours.searchMergeContacted.stepC.intro,
      key: SEARCH_MERGE_AUCTION_STARTED_STEPS.STATUS,
      step: 3,
      title: (t: Translations) => t.tours.searchMergeContacted.stepC.title,
    },
  },
} as const;
